import React, { ChangeEvent, ReactElement, useState } from 'react';
import Button from '@material-ui/core/Button';

type Props = {
  id: string;
  label: string;
  accept?: string;
  onChange: (files: FileList | null) => void;
};
function FileSelectButton(props: Props): ReactElement {
  const { id, label } = props;

  const [reset, setReset] = useState(1);

  function onChange(ev: ChangeEvent<HTMLInputElement>): void {
    props.onChange(ev.target.files);
    setReset(reset + 1);
  }

  return (
    <>
      <input
        key={reset}
        id={id}
        type="file"
        style={{ display: 'none' }}
        accept={props.accept}
        onChange={onChange}
      />

      <label htmlFor={id}>
        <Button variant="contained" fullWidth component="span">
          {label}
        </Button>
      </label>
    </>
  );
}

export default FileSelectButton;
